module.exports = __webpack_public_path__ + "img/pro_top.d70fe018.png";